// extracted by mini-css-extract-plugin
export default {"cardBody":"style_cardBody__UJXJg","hoveredCardBody":"style_hoveredCardBody__Xeiic","cardBodyNotClickable":"style_cardBodyNotClickable__nSKRX"};